import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import {
  Button,
  Checkbox,
  Col,
  HelpBlock,
  PageHeader,
  Panel,
  Row,
} from 'react-bootstrap'

import Currency from 'internal-components/src/components/Currency'
import Duration from 'internal-components/src/components/Duration'
import Icon from 'internal-components/src/components/Icon'
import PaymentMethod from 'internal-components/src/components/Payment/Method'
import { FormGroup } from 'internal-components/src/components/Form'
import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { selectPaymentTokensForClient } from 'internal-components/src/redux/modules/paymentToken'

import CouponCode from '../../components/Signup/CouponCode'
import ProgressSummary from '../../components/Signup/ProgressSummary'
import createSignupProgress, {
  SignupProgressRecord,
} from '../../records/SignupProgress'
import * as signupActions from '../../redux/modules/signupEdit/actions'
import {
  selectErrorsByPath,
  selectEditSignupWithExternals,
} from '../../redux/modules/signupEdit/selectors'

class SummaryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async handleSubmit() {
    if (!this.props.signupWithExternals.signup.get('agreeTerms')) {
      this.props.addErrors([
        {message: 'You must agree to the terms and conditions.', path: 'terms'}
      ]);
      return;
    }
    const { signupWithExternals } = this.props;
    const token = signupWithExternals.signup.get('token');
    const paymentRequired = !signupWithExternals.billingGroup || signupWithExternals.billingGroup.token_required
    if (paymentRequired && !token) {
      this.setState({tokenisingNewCard: true});
      const tokenResult = await this.tokeniseSquareCard();
      this.setState({tokenisingNewCard: false});

      const pricedByExtensions = signupWithExternals.offer.attributes.has('price_by_extensions');

      let priceMultiplier = 1, phoneExtensionCount;
      if (pricedByExtensions) {
        phoneExtensionCount = priceMultiplier = signupWithExternals.signup.data.get('phone-ext-count') || 1;
      }

      const signup = signupWithExternals.signup
      const firstPayment = (signup.get('setupAmount') + signup.get('recurringAmount')) * priceMultiplier
      const paymentRequired =
        !signupWithExternals.billingGroup ||
        signupWithExternals.billingGroup.token_required

      if (!tokenResult) {
        return;
      }

      const {nonce, contactDetails} = tokenResult;

      this.props.submit(nonce, contactDetails);
    } else {
      this.props.submit();
    }
  }
  render() {
    const {
      agreeTerms,
      applyCoupon,
      errors,
      selectToken,
      setCoupon,
      signupProgress,
      signupWithExternals,
      submit,
      tokens,
    } = this.props;
    const working = this.props.working || this.state.tokenisingNewCard;

    const pricedByExtensions = signupWithExternals.offer.attributes.has('price_by_extensions');

    let priceMultiplier = 1, phoneExtensionCount;
    if (pricedByExtensions) {
      phoneExtensionCount = priceMultiplier = signupWithExternals.signup.data.get('phone-ext-count') || 1;
    }

    const signup = signupWithExternals.signup
    const firstPayment = signup.get('setupAmount') + signup.get('recurringAmount') * priceMultiplier
    const paymentRequired =
      !signupWithExternals.billingGroup ||
      signupWithExternals.billingGroup.token_required

    // Note: useState and useEffect not available in this version of React.
    // Storing data in global window object as a workaround.
    if (!window.didAutoCoupon) {
      window.didAutoCoupon = true;
      // Automatically apply coupon if appropriate
      if (signupWithExternals.coupon === null &&
        !signupWithExternals.offer.attributes.includes('calix') &&
        signupWithExternals.product.type == 'VDSL') {
        if (signupWithExternals.offer.attributes.includes('personal')) {
          setCoupon('VISION20OFF');
        } else {
          setCoupon('MYVISION2024');
        }
        applyCoupon();
      }
    }

    return (
      <section className="container">
        <PageHeader>
          {signup.reference && (
            <small className="pull-right">{signup.reference}</small>
          )}
          Signup Summary and Payment
        </PageHeader>

        <ProgressSummary
          signupProgress={signupProgress}
          signupWithExternals={signupWithExternals}
        />

        <form onSubmit={(e) => { e.preventDefault(); this.handleSubmit(); }} noValidate>
          <Row>
            <Col md={12}>
              <h4>Coupon Code</h4>

              <CouponCode
                applyCoupon={applyCoupon}
                coupon={signup.get('coupon') || ''}
                errors={errors}
                hasCoupon={signup.get('hasCoupon')}
                setCoupon={setCoupon}
                working={working}
              />
            </Col>
          </Row>

          {paymentRequired && (
            <Row>
              <Col md={12}>
                <h4>Payment Details</h4>

                <PaymentMethod
                  allowNewCard
                  bsSize="large"
                  errors={errors}
                  selectedToken={signup.get('token')}
                  selectToken={selectToken}
                  setClear={clear => this.clearSquareCard = clear}
                  setTokenise={tokenise => this.tokeniseSquareCard = tokenise}
                  tokens={tokens}
                />

                <Panel>
                  <Panel.Body>
                    Infinite Networks will conduct an additional check to ensure
                    we can provide you the requested service. We will charge your
                    supplied credit card{' '}
                    <strong>
                      <Currency amount={firstPayment}/>
                    </strong>{' '}
                    for setup and the first{' '}
                    <Duration
                      duration={signupWithExternals.offer.period}
                    />{' '}
                    of your service.
                  </Panel.Body>
                </Panel>
              </Col>
            </Row>
          )}

          <Row>
            <Col md={12}>
              <FormGroup
                bsSize="large"
                controlId="terms"
                errors={errors}
                errorKey="terms"
              >
                <Checkbox
                  id="agreeTerms"
                  checked={!!signup.get('agreeTerms')}
                  onChange={e => agreeTerms(e.target.checked)}
                >
                  I agree to the Infinite Networks{' '}
                  <span className="text-muted">Standard Terms and Conditions</span>{' '}
                  and the{' '}
                  <span className="text-muted">Acceptable Use Policy</span>.
                </Checkbox>

                <HelpBlock>
                  Our{' '}
                  <a
                    href="https://www.infinite.net.au/wp-content/uploads/2025/12/Infinite-Networks-Pty-Ltd-Standard-Terms-and-Conditions.pdf"
                    target="_blank">
                    Standard Terms and Conditions
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://www.infinite.net.au/wp-content/uploads/2023/10/INFINITE-NETWORKS-Acceptable-Use-and-Fair-Use-Policy.pdf"
                    target="_blank">
                    Acceptable Use Policy
                  </a>{' '}
                  are available{' '}
                  <a href="https://www.infinite.net.au/policies-agreements/" target="_blank">
                    here
                  </a>
                  .
                </HelpBlock>
              </FormGroup>

              <Button bsSize="large" type="submit" disabled={working}>
                Submit Signup <Icon name="thumbs-up" spin={working}/>
              </Button>
            </Col>
          </Row>
        </form>
      </section>
    )
  }
}

SummaryView.propTypes = {
  agreeTerms: Pt.func.isRequired,
  applyCoupon: Pt.func.isRequired,
  errors: Ipt.map.isRequired,
  selectToken: Pt.func.isRequired,
  setCoupon: Pt.func.isRequired,
  signupProgress: Pt.instanceOf(SignupProgressRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
  submit: Pt.func.isRequired,
  tokens: Ipt.orderedSet.isRequired,
  working: Pt.bool.isRequired,
}

const mapStateToProps = state => {
  const signupWithExternals = selectEditSignupWithExternals(state, {
    sortBy: null,
  })

  return {
    card: state.signupEdit.get('card'),
    errors: selectErrorsByPath(state.signupEdit),
    signupProgress: createSignupProgress(
      signupWithExternals,
      state.signupEdit.get('errors'),
      'summary',
    ),
    signupWithExternals,
    tokens: selectPaymentTokensForClient(state.paymentToken, {
      clientId: signupWithExternals.signup.clientId || undefined,
      tokenUuid: signupWithExternals.signup.token,
    }),
    working: state.signupEdit.getIn(['meta', 'working']),
  }
}

export default connect(
  mapStateToProps,
  signupActions,
)(SummaryView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/SummaryView.jsx